// Titles and meta descriptions sized for search results (Google cuts titles at about 60 characters and descriptions at about 155-160).
export const MAX_TITLE = 60;
export const MAX_DESCRIPTION = 155;
const MIN_USEFUL = 110;                 // a description shorter than this wastes the space search results give it

const tidy = s => String(s || "").replace(/\s+/g, " ").trim();
const asSentence = s => { s = tidy(s); return s && !/[.!?…]$/.test(s) ? s + "." : s; };

// Builds a description from a list of texts (a tagline, then body copy): whole sentences while they fit, otherwise a cut at a word
// boundary with an ellipsis. Never glues one text onto the next without punctuation.
export function seoDescription(...texts) {
  const sentences = texts.flatMap(t => tidy(t).split(/(?<=[.!?])\s+/)).map(asSentence).filter(Boolean);
  let out = "";
  for (const s of sentences) {
    const next = out ? out + " " + s : s;
    if (next.length <= MAX_DESCRIPTION) { out = next; continue; }
    if (!out) {                                       // even the first sentence is too long: cut it at a word boundary
      const cut = next.slice(0, MAX_DESCRIPTION - 1).replace(/\s+\S*$/, "").replace(/[\s,;:–—-]+$/, "");
      return cut + "…";
    }
    // The next sentence doesn't fit whole. If what we have is short, fill up to the limit with part of it, cut at a word boundary.
    if (out.length < MIN_USEFUL) {
      const room = MAX_DESCRIPTION - out.length - 2;            // space + ellipsis
      const cut = s.slice(0, room).replace(/\s+\S*$/, "").replace(/[\s,;:–—-]+$/, "");
      if (cut.length > 20) out = out + " " + cut + "…";
    }
    break;
  }
  return out;
}

export const pageTitle = name => `${tidy(name)} | AXIS360 Assess`;
